<template minapp="mpx" xlang="wxml">
  <es-layout
    left-arrow
    layout="{{['header', 'footer']}}"
    title="{{title}}"
    navbarStyle="{{navbarStyle}}"
    navbarUseWebBack="{{useWebBack}}"
    navbarClickLeft="{{goback}}"
  >
    <view class="page-body">
      <view class="page-body__block" wx:for="{{content}}" wx:key="index">
        <view class="page-title">{{ item[titleKey] }}</view>
        <view class="page-text">
          <view class="page-text__item" wx:for="{{item[listKey]}}" wx:for-item="text">
            {{ text }}
          </view>
        </view>
      </view>
    </view>
    <view class="es-service__footer" slot="footer">
      <es-button
        block
        type="info"
        bind:click="showDialog"
        class="custom-button"
        custom-class="button-radius"
      >
        联系客服
      </es-button>
    </view>
    <!-- 电话弹窗 -->
    <TsDrawer
      title="联系客服"
      show="{{ isShowDialog }}"
      showMask="{{ true }}"
      centerTitle="{{ false }}"
      headerStyle="{{headerStyle}}"
      bind:close="closeDialog"
    >
      <HelpDeskChat
        bizType="train"
        onlineSource="{{onlineSource}}"
        onlineOrderId="{{onlineOrderId}}"
        phone="{{phoneText}}"
      />
    </TsDrawer>
  </es-layout>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { goback, query } from '@didi/spring-base'

  createComponent({
    props: {
      title: {
        type: String,
        value: '联系客服'
      },

      // 循环列表title别名
      titleKey: {
        type: String,
        value: 'assist_title'
      },

      // 循环列表key别名
      listKey: {
        type: String,
        value: 'assist_list'
      },

      content: {
        type: Array,
        value: []
      },

      phone: {
        type: String,
        optionalTypes: [Number]
      },

      globalPhone: {
        type: String,
        optionalTypes: [Number]
      },

      useWebBack: {
        type: Boolean,
        value: false
      }
    },
    ready() {
      this.onlineOrderId = query().orderId
      this.onlineSource = query().source
      if(query().actionType === 'help') {
        setTimeout(()=>{
          this.showDialog()
        }, 500)
      }
    },
    computed: {
      phoneText() {
        let phone = this.phone + ''
        if (phone.startsWith('400') && phone.length > 6) {
          const arr = phone.split('')
          arr.splice(3, 0, ' ')
          arr.splice(7, 0, ' ')
          phone = arr.join('')
        }
        return phone || this.globalPhone + ''
      }
    },

    data: {
      navbarStyle: {
        backgroundColor: '#ffffff'
      },
      isShowDialog: false,
      onlineOrderId: '',
      onlineSource: '',
      headerStyle: {
        padding: '18px',
        justifyContent: 'flex-start',
        fontSize: '19px',
        fontWeight: '500',
        fontFamily: 'PingFangSC-Medium',
        color: '#000'
      }
    },

    methods: {
      goback() {
        goback()
      },
      showDialog() {
        this.isShowDialog = true
      },

      closeDialog() {
        this.isShowDialog = false
      },
    }
  })
</script>

<style lang='stylus' scoped>
  .page-body
    padding 10px 16px
    height 100%
    background #fff
    overflow-y auto
    &__block
      margin-bottom 10px
  .page-title
    font-family PingFangSC-Medium
    font-size 15px
    color #000000
    margin-bottom 10px
  .page-text
    font-family PingFangSC-Regular
    font-size 14px
    color #666666
    text-align justify
    line-height 22px
    &__item
      margin-bottom 5px
      &::before
        content ''
        display inline-block
        width 4px
        height 4px
        background #999
        border-radius 100%
        vertical-align middle
        margin-right 5px
  .page-action
    padding 15px 10px
  .custom-button
    flex 1
  .es-service__footer
    flex 1
    position relative
    padding 20px 16px
    background #fff
    box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
  .button-radius
    border-radius 8px !important
  .popup-button
    color #1473FF !important
    font-size 16px
    border-radius 8px !important
  .popuo-call
    display flex
    align-items center
    justify-content center
  .call-dialog
    padding 32px 16px 50px
    background #FFF
    border-radius 16px 16px 0 0
  .call-title
    font-family PingFangSC-Medium
    font-size 24px
    color #000
    font-weight 500
    padding-bottom 16px
  .call-item
    display flex
    padding 12px 0
    width 100%
    &+.call-item
      border-top 1px solid #EBEBEB
  .item-left
    margin-right 7px
    width 36px
    height 36px
    border-radius 8px
    display flex
    align-items center
    justify-content center
    &.inner
      background #CFC7F6
    &.global
      background #47C1FF
  .item-right
    flex 1
  .call-text
    font-family PingFangSC-Medium
    font-size 16px
    color #444
    letter-spacing 0
    font-weight 500
  .call-number
    font-family PingFangSC-Regular
    font-size 14px
    color #999
    letter-spacing 0
    font-weight 400
  .cancel-button
    margin-top 12px
    width 100%
    height 48px
    line-height 48px
    font-family PingFangSC-Medium
    font-size 16px
    color #333
    text-align center
    font-weight 500
    background rgba(0, 0, 0, 0.06)
    border-radius 8px
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-layout': '@/es-mpx-ui/lib/layout',
      'es-button': '@didi/es-mpx-ui/lib/button/index',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      HelpDeskChat: '@didi/spring-ui/help-desk-chat',
      TsDrawer: '@didi/spring-ui/ts-drawer'
    }
  }
</script>
